import React from 'react'

import { Dropdown, type DropdownOption } from '@/components/ui'
import { DATA_SOURCE_VALUES, type DataSource, DEFAULT_DATA_SOURCE } from '@/types/data-source'

const options: DropdownOption[] = [
  { value: DATA_SOURCE_VALUES.fresh, label: 'Fresh' },
  { value: DATA_SOURCE_VALUES.timescale, label: 'Timescale' },
]

interface DataSourceDropdownProps {
  value: DataSource | undefined
  onChange: (value: DataSource) => void
  /** Rendered above the control; omit on the map, where space is tight. */
  label?: string
  id?: string
  className?: string
}

/**
 * Picks which back end serves this insight (or page) while Fresh and Timescale run in
 * parallel, so the same view can be put side by side against both.
 *
 * Only shown to users granted the permission — see useCanSelectDataSource. Defaults to
 * Fresh, which is what everyone without the permission gets.
 */
const DataSourceDropdown = ({ value, onChange, label, id = 'dataSource', className }: DataSourceDropdownProps) => (
  <div className={className}>
    {label ? <label className="block text-base-content mb-2">{label}</label> : null}
    <Dropdown
      id={id}
      options={options}
      selectedItem={options.find((o) => o.value === (value ?? DEFAULT_DATA_SOURCE)) ?? options[0]}
      handleSingleSelectItem={(option: DropdownOption | null) => {
        onChange((option?.value as DataSource) || DEFAULT_DATA_SOURCE)
      }}
      isClearable={false}
      placeholder="Data source"
    />
  </div>
)

export default DataSourceDropdown
